export default __webpack_public_path__ + "fdb4e0d53b88320e6ee0a2512de20865.svg";